import * as ActionTypes from './ActionType';

export const User = (state = {
    errMess: null,
    isLogging: false,
    data: null
}, action) => {
    switch(action.type){
        case ActionTypes.ADD_USER:
            return {...state, errMess: null, isLogging: false, data: action.payload};
        case ActionTypes.USER_RESET:
            return {...state, errMess: null, isLogging: false, data: null};
        case ActionTypes.USER_FAILED:
            return {...state, errMess: action.payload, isLogging: false, data:null};
        case ActionTypes.USER_LOGGING:
            return {...state, errMess: null, isLogging: true, data:null};
        case ActionTypes.ADD_PORT:
          return {...state, errMess: null,  isLogging: false, data: {
              ...state.data,
              ports_list: [...state.data.ports_list, {value:action.payload, label:action.payload}],
            },
          };
        default:
            return state;
    }
}
